import { apiConfig } from '../../../common/apiConfig'
import { createUserStore } from '../../../common/user/createUserStore'
import {
  AdminProfileApi,
  SignOutRequestRoleEnum,
  UserSessionsApi,
  UserSignInRequestRoleEnum,
} from '../../../generated'

export const defaultLocation = '/admin/applications'
export const login = '/admin'

const api = new AdminProfileApi(apiConfig)
const _load = api.currentProfile.bind(api)

const sapi = new UserSessionsApi(apiConfig)

async function _signIn(account: string, password: string, keep: boolean) {
  return sapi.userSignIn({ account, password, keep, role: UserSignInRequestRoleEnum.Aao })
}

async function _signOut() {
  return sapi.userSignOut({ role: SignOutRequestRoleEnum.Aao })
}

export const { signOut, onSignOut, onError, useUser } = createUserStore(_load, _signIn, _signOut)
